export function bothOrEmpty(inValue, outValue, origIn, origOut) {
	const bothEmpty = !inValue && !outValue;
	const bothFilled = !!inValue && !!outValue;
	const bothUnchanged = inValue === origIn && outValue === origOut;
	return bothEmpty || bothFilled || bothUnchanged;
}
